module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mega-menu/menu-style2/menu-style2.component.scss
// module id = ./src/app/mega-menu/menu-style2/menu-style2.component.scss
// module chunks = main